import React, { useEffect, useMemo } from 'react'
import { Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom'
import { authRoutes, usePublicRoutes } from './router.link';
import Header from '../../core/common/header';
import Sidebar from '../../core/common/sidebar';
import ThemeSettings from '../../core/common/theme-settings/themeSettings';
import { useDispatch, useSelector } from 'react-redux';
import Error404 from '../pages/error/error-404';
import DealsDashboard from '../mainMenu/dealsDashboard';
import { useFormik } from 'formik';
import { useRenewTokenMutation } from '../../services/EndPointsApis';
import { setUser } from '../../Features/authslice';

const ALLRoutes = () => {

  const publicRoutes = usePublicRoutes();
  const [renewToken, { data: renewTokenData, isSuccess }] = useRenewTokenMutation();
  const dispatch = useDispatch();
  const userToken = useSelector((per: any) => per?.auth?.userDetail?.token);
  const navigate = useNavigate();



  const HeaderLayout = useMemo(() => (
    <>
      <Header />
      <Sidebar />
      <Outlet />
      <ThemeSettings />
    </>
  ), []);
  const AuthPages = useMemo(() => (
    <>
      <Outlet />
    </>
  ), []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      renewToken('');
    }, 14100000);
    return () => clearInterval(intervalId);
  }, [renewToken]);

  useEffect(() => {
    if (isSuccess && renewTokenData?.result) {
      dispatch(
        setUser({
          ...renewTokenData?.result?.userAccountBasicInfo,
          token: renewTokenData.result.token,
          // expiresAt: renewTokenData.result.expiresAt,
        })
      );
    }
  }, [isSuccess]);

  // useEffect(() => {
  //   if (!userToken) {
  //     navigate("/");
  //   }
  // }, [userToken]);

  return (
    <>
      <Routes>
        {!userToken ?
          <Route path={"/"} element={AuthPages}>
            {authRoutes.map((route, idx) => (
              <>
                <Route path={route.path} element={route.element} key={route.path} />
              </>
            ))}
          </Route> :
          <Route path={"/"} element={HeaderLayout}>
            {publicRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={route.path} />
            ))}
            <Route index element={<Navigate to='/dashboard' />}/>
          </Route>}
        <Route path="*" element={<Navigate to='/' />} />
      </Routes>
    </>
  )
}

export default ALLRoutes
